import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppProvider } from './providers/app-provider';
import { AppErrorBoundary } from './components/error-boundaries';
import App from './app.tsx';

import './index.css';

// Register service worker for offline functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js');
      console.log('Service Worker registered successfully:', registration);
    } catch (error) {
      console.error('Service Worker registration failed:', error);
    }
  });
}

// Handle online/offline status
window.addEventListener('online', () => {
  console.log('App is online');
  // Trigger vault data sync if needed
  if (navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: 'SYNC_VAULT_DATA'
    });
  }
});

window.addEventListener('offline', () => {
  console.log('App is offline');
  // You could show an offline indicator here
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppErrorBoundary>
      <AppProvider>
        <App />
      </AppProvider>
    </AppErrorBoundary>
  </StrictMode>,
)
